<template>
	<Bar :data="data" :options="options" />
</template>

<script>
import { Bar } from 'vue-chartjs'
import { useChart } from '@/composables/useChart'

const BarChart = {
	props: ['data', 'options'],
	components: { Bar },
	setup () {
		useChart()
	}
}

export default BarChart
export { BarChart as mdbBarChart }
</script>
